export default __webpack_public_path__ + "static/media/Group 1219.80138caa.svg";